import React, { useEffect, useRef, useState } from 'react';

const ASSET_PATH = '/images';

export function PaymentMethodSheet({ isVisible, onClose, onSelect }) {
    const sheetRef = useRef(null);
    const contentRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);

    const paymentMethods = {

        cards: [
            {
                id: 'antilopay',
                name: 'AntiloPay',
                subtitle: 'Система быстрых платежей',
                icon: 'antilopay.jpg',
                iconType: 'full',
                type: 'antilopay'
            }
            ,
            {
                id: 'mulenpay',
                name: 'MulenPay',
                subtitle: 'Система быстрых платежей',
                icon: 'mulen.jpg',
                iconType: 'full',
                type: 'mulenpay'
            }

        ],
        credit:[
            {
                id: 'lavapay',
                name: 'LavaPay',
                subtitle: 'Банковские карты',
                icon: 'lavapay.jpg',
                iconType: 'full',
                type: 'lavapay'
            }
        ],
        crypto: [
            {
                id: 'heleket',
                name: 'Heleket',
                subtitle: 'USDT | BTC | ETH | LTC и т.д.',
                icon: 'heleket.jpg',
                iconType: 'full',
                type: 'crypto'
            },
            {
                id: 'cryptobot',
                name: 'CryptoBot',
                subtitle: 'P2P',
                icon: 'Cryptobot.jpg',
                iconType: 'full',
                type: 'crypto'
            }
        ]
    };

    useEffect(() => {
        if (isVisible) {
            setIsOpen(true);
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            setIsOpen(false);
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    // Обработчики для свайпа
    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null || !sheetRef.current) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);
            sheetRef.current.style.transform = `translateY(${diff}px)`;
        }
    };

    const handleTouchEnd = (e) => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            handleClose();
        } else {
            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }
        }

        setStartY(null);
        setCurrentY(null);
    };

    // Обработчики для мыши
    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null || !sheetRef.current) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);
                sheetRef.current.style.transform = `translateY(${diff}px)`;
            }
        };

        const handleMouseUp = (e) => {
            const diff = currentY || 0;

            if (diff > 100) {
                handleClose();
            } else {
                if (sheetRef.current) {
                    sheetRef.current.style.transform = '';
                }
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const handleSelect = (method) => {
        onSelect(method);
        handleClose();
    };

    // Запрещаем прокрутку колесиком мыши
    const handleWheel = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // Запрещаем прокрутку на touch-устройствах
    const handleTouchMoveContent = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100000,
            pointerEvents: 'none',
            overflow: 'hidden'
        }}>
            {/* Затемнение */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                backdropFilter: 'blur(3px)',
                opacity: isOpen ? 1 : 0,
                transition: 'opacity 0.3s ease',
                pointerEvents: isOpen ? 'auto' : 'none',
            }} onClick={handleClose} />

            {/* Шторка */}
            <div
                ref={sheetRef}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: '#0b1217',
                    borderTopLeftRadius: '32px',
                    borderTopRightRadius: '32px',
                    boxShadow: '0 -4px 30px rgba(0, 0, 0, 0.5)',
                    pointerEvents: 'auto',
                    transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
                    transition: currentY ? 'none' : 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                    maxHeight: '90vh',
                    overflow: 'hidden', // Скрываем переполнение
                }}
                onWheel={handleWheel} // Запрещаем прокрутку колесиком
            >
                {/* Фоновый вектор */}
                <img
                    src={`${ASSET_PATH}/0_596.svg`}
                    alt=""
                    style={{
                        position: 'absolute',
                        left: '-93px',
                        top: '151px',
                        width: '776px',
                        height: '929px',
                        zIndex: 0,
                        pointerEvents: 'none',
                        opacity: 0.5,
                    }}
                />

                <div
                    ref={contentRef}
                    style={{
                        position: 'relative',
                        zIndex: 1,
                        maxWidth: '386px',
                        margin: '0 auto',
                        padding: '16px 16px 24px 16px',
                        overflow: 'hidden', // Полностью запрещаем прокрутку
                        maxHeight: 'calc(90vh - 40px)',
                        overflowY: 'auto', // Явно запрещаем вертикальную прокрутку
                    }}
                    onWheel={handleWheel}
                    onTouchMove={handleTouchMoveContent}
                >
                    {/* Ползунок для закрытия */}
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '8px 0 16px 0',
                            cursor: 'grab',
                            touchAction: 'none',
                            userSelect: 'none',
                        }}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div style={{
                            width: '40px',
                            height: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            borderRadius: '2px',
                        }} />
                    </div>

                    {/* Заголовок */}
                    <h2 style={{
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: 600,
                        textAlign: 'center',
                        marginBottom: '24px'
                    }}>
                        Выберите способ оплаты
                    </h2>
                    {/* Банковские карты */}
                    <div style={{ marginBottom: '24px' }}>
                        <h3 style={{
                            color: '#ffffff',
                            fontSize: '12px',
                            fontWeight: 500,
                            marginBottom: '16px',
                        }}>Система быстрых платежей</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {paymentMethods.cards.map(method => (
                                <div
                                    key={method.id}
                                    onClick={() => handleSelect(method)}
                                    style={{
                                        backgroundColor: 'rgba(200, 255, 227, 0.1)',
                                        backdropFilter: 'blur(1px)',
                                        borderRadius: '24px',
                                        padding: '12px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.15)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.1)'}
                                >
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        flexShrink: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>
                                        <img
                                            src={`${ASSET_PATH}/${method.icon}`}
                                            alt={method.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                borderRadius: '16px',
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <span style={{ color: '#ffffff', fontSize: '14px', fontWeight: 500 }}>{method.name}</span>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '12px' }}>{method.subtitle}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Карты */}
                    <div style={{ marginBottom: '24px' }}>
                        <h3 style={{
                            color: '#ffffff',
                            fontSize: '12px',
                            fontWeight: 500,
                            marginBottom: '16px',
                        }}>Банковские карты</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px'}}>
                            {paymentMethods.credit.map(method => (
                                <div
                                    key={method.id}
                                    onClick={() => handleSelect(method)}
                                    style={{
                                        backgroundColor: 'rgba(200, 255, 227, 0.1)',
                                        backdropFilter: 'blur(1px)',
                                        borderRadius: '24px',
                                        padding: '12px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.15)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.1)'}
                                >
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        flexShrink: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#141917',
                                        borderRadius: '16px',
                                    }}>
                                        <img
                                            src={`${ASSET_PATH}/${method.icon}`}
                                            alt={method.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                borderRadius: '16px'
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <span style={{ color: '#ffffff', fontSize: '14px', fontWeight: 500 }}>{method.name}</span>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '12px' }}>{method.subtitle}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Криптовалюта */}
                    <div style={{ marginBottom: '24px' }}>
                        <h3 style={{
                            color: '#ffffff',
                            fontSize: '12px',
                            fontWeight: 500,
                            marginBottom: '16px',
                        }}>Криптовалюта</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '0 0 100px 0'}}>
                            {paymentMethods.crypto.map(method => (
                                <div
                                    key={method.id}
                                    onClick={() => handleSelect(method)}
                                    style={{
                                        backgroundColor: 'rgba(200, 255, 227, 0.1)',
                                        backdropFilter: 'blur(1px)',
                                        borderRadius: '24px',
                                        padding: '12px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.15)'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.1)'}
                                >
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        flexShrink: 0,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#141917',
                                        borderRadius: '16px',
                                    }}>
                                        <img
                                            src={`${ASSET_PATH}/${method.icon}`}
                                            alt={method.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                borderRadius: '16px'
                                            }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <span style={{ color: '#ffffff', fontSize: '14px', fontWeight: 500 }}>{method.name}</span>
                                        <span style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '12px' }}>{method.subtitle}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}